import UniversalCard from './UniversalCard';

export default UniversalCard;
